export default __webpack_public_path__ + "static/media/defient-stack4.webp";